import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';
import { RolesGuard } from './core/auth/guards/roles.guard';


export const appRoutes: Route[] = [

    { path: '', pathMatch: 'full', redirectTo: 'landing' },
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'landing', loadChildren: () => import('app/modules/admin/landing/landing.module').then(m => m.LandingModule) },
        ]
    },
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboards/project' },
    // Auth routes for guests
    {
        path: '',
        // canActivate: [NoAuthGuard],
        // canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule) },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule) },
            { path: 'regn', loadChildren: () => import('app/modules/admin/core/regn/regn.module').then(m => m.RegnModule) },
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        // canActivate: [AuthGuard],
        // canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule) },
        ]
    },


    // Admin routes
    {
        path: '',
        // canActivate: [AuthGuard, RolesGuard],
        // canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [

            // Dashboards
            {
                path: 'dashboards', children: [
                    { path: 'project', loadChildren: () => import('app/modules/admin/dashboards/project/project.module').then(m => m.ProjectModule) },
                ]
            },

            {
                path: 'itr', children: [
                    { path: 'desc', loadChildren: () => import('app/modules/admin/core/itr-filing/itr-filling.module').then(m => m.ItrFillingDescModule) }
                ]
            },
            {
                path: 'svc', children: [
                    { path: 'svcReq', loadChildren: () => import('app/modules/admin/core/svc-rqst/svc-rqst.module').then(m => m.SvcRqstModule) }
                ]
            },
            {
                path: 'tx', children: [
                    { path: 'tx-inq', loadChildren: () => import('app/modules/admin/core/tax-inquiry/tax-inq.module').then(m => m.TaxInqModule) }
                ]
            },
            {
                path: 'csul', children: [
                    { path: 'csul-svc', loadChildren: () => import('app/modules/admin/core/csul-svc-dtl/csul-svc-dtl.module').then(m => m.CsulSvcDtlModule) }
                ]
            },
            {
                path: 'usr', children: [
                    { path: 'usr-svc', loadChildren: () => import('app/modules/admin/core/usr/usr.module').then(m => m.UsrModule) }
                ]
            },


            //Settings
            {
                path: 'admin', children: [
                    { path: 'org', loadChildren: () => import('app/modules/admin/core/org/org.module').then(m => m.OrgModule) },
                    { path: 'usr', loadChildren: () => import('app/modules/admin/core/usr/usr.module').then(m => m.UsrModule) },
                    { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule) },
                ]
            },
            {
                path: 'profile', children: [
                    { path: '', loadChildren: () => import('app/modules/admin/core/usr/usr.module').then(m => m.UsrModule) },
                    { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule) }
                ]
            },

            //Payment

            {
                path: 'payment',
                loadChildren: () => import('app/modules/admin/payment/payment.module').then(m => m.PaymentModule)
            },

            // 404 & Catch all
            { path: '404-not-found', pathMatch: 'full', loadChildren: () => import('app/modules/admin/pages/error/error-404/error-404.module').then(m => m.Error404Module) },
            { path: '**', redirectTo: '404-not-found' }
        ]
    }
];
